import React from 'react';

const Profile = (props) => {
    const profileObj = props.profileData;
    const consultObj = props.consultData.map((item,i) => {
        if (item.label === 'Information'){
            return (
                <li key={item.label+i} className="information text-center">
                    {item.text}
                </li>
            )
        } else {
            return (
                <li key={item.label}>
                    {item.label}: {item.start} {item.end}
                </li>
            )
        }
    });
    return <div>
    <div className="profileImg"><img className="img-circle center-block" src={profileObj.picture} width="200" alt={profileObj.name}/></div>
        <h1 className="text-center">{profileObj.name}</h1>
        <h3 className="text-center">{profileObj.label}</h3>
        <div className="divider"></div>
        <ul className="list-unstyled contact-links text-center">
            <li><i className="fa fa-lg fa-location-arrow"></i>{profileObj.location.address} <br/> {profileObj.location.city}, {profileObj.location.countryCode}</li>
            <li><i className="fa fa-lg fa-phone"></i>{profileObj.phone}</li>
            <li><i className="fa fa-lg fa-fax"></i>{profileObj.fax}</li>
            <li><i className="fa fa-lg fa-envelope"></i><a href={`mailto${profileObj.email}`}>{profileObj.email}</a></li>
        </ul>
        <div className="divider"></div>
        <ul className="list-unstyled">
            {consultObj}
        </ul>
        <div className="divider"></div>
    </div>
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Profile.js